import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatStrikethroughIcon from "@mui/icons-material/FormatStrikethrough";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import { Text, ToggleButton, ToggleButtonGroup } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	const [value, setValue] = useState(["bold", "italic"]);

	const onChange = (event: object, value: string[]) => {
		setValue(value);
	};

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="enabled" />
			<Text semiBold text="disabled" />
			<ToggleButtonGroup
				aria-label="format"
				onChange={onChange}
				value={value}
			>
				<ToggleButton
					aria-label="bold"
					tooltipProps={{ res: "FormatBold" }}
					value="bold"
				>
					<FormatBoldIcon />
				</ToggleButton>
				<ToggleButton
					aria-label="italic"
					tooltipProps={{ res: "FormatItalic" }}
					value="italic"
				>
					<FormatItalicIcon />
				</ToggleButton>
				<ToggleButton
					aria-label="underline"
					tooltipProps={{ res: "FormatUnderline" }}
					value="underline"
				>
					<FormatUnderlinedIcon />
				</ToggleButton>
				<ToggleButton
					aria-label="strikethrough"
					tooltipProps={{ res: "FormatStrikethrough" }}
					value="strikethrough"
				>
					<FormatStrikethroughIcon />
				</ToggleButton>
			</ToggleButtonGroup>
			<ToggleButtonGroup
				aria-label="format"
				value={["bold", "italic"]}
			>
				<ToggleButton
					aria-label="bold"
					disabled
					tooltipProps={{ res: "FormatBold" }}
					value="bold"
				>
					<FormatBoldIcon />
				</ToggleButton>
				<ToggleButton
					aria-label="italic"
					disabled
					tooltipProps={{ res: "FormatItalic" }}
					value="italic"
				>
					<FormatItalicIcon />
				</ToggleButton>
				<ToggleButton
					aria-label="underline"
					disabled
					tooltipProps={{ res: "FormatUnderline" }}
					value="underline"
				>
					<FormatUnderlinedIcon />
				</ToggleButton>
				<ToggleButton
					aria-label="strikethrough"
					disabled
					tooltipProps={{ res: "FormatStrikethrough" }}
					value="strikethrough"
				>
					<FormatStrikethroughIcon />
				</ToggleButton>
			</ToggleButtonGroup>
		</CssColumnGrid>
	);
};